module.exports = __webpack_public_path__ + "img/blt-arrow02_r.25efef88.svg";